import React, { Fragment } from 'react';
import ScrollLock from 'react-scrolllock';
import './instructions.css';
import walk1 from '../../../../images/ParkingLots/Instructions/Toronto/walk1.png';
import drive1 from '../../../../images/ParkingLots/Instructions/Toronto/drive1.png';
import drive2 from '../../../../images/ParkingLots/Instructions/Toronto/drive2.jpg';
import bloormap from '../../../../images/ParkingLots/Instructions/Toronto/bloormap.png';
import { Helmet } from 'react-helmet';

const BloorInstructions = () => (
  <Fragment>
    <Helmet>
      <title>Autzu | Parking Instructions</title>
      <meta
        name="description"
        content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
      />
    </Helmet>
    <div className="instructions">
      <ScrollLock>
        <div className="instructions__container">
          <div className="instructions__title_container">
            <div className="instructions__title">
              Finding the Parking Hub
            </div>
            <div className="instructions__subtitle">280 Bloor St. W</div>
          </div>
          <div className="instructions__body">
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>How do I access the parking lot?</strong>
              </div>
              <img className="instructions__image" src={bloormap} />
              <p className="instructions__body-text">
                Autzu EV vehicles are parked in the Indigo parking facility
                at the Kimpton Hotel Saint George, 280 Bloor St. W,
                Toronto, ON M5S 1V8.
              </p>
              <p className="instructions__body-text">
                The closest major intersection is Bloor St W and Spadina
                Ave.
              </p>
              <p className="instructions__body-text">
                The parking location is a 20-second walk from St. George
                subway station or a 5-minute walk from Spadina subway
                station.
              </p>
            </div>
            <br />
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot by walking?
                </strong>
              </div>

              <p className="instructions__body-text">
                Enter the Kimpton Hotel through the main entrance doors and
                walk to the elevator lobby. Take the elevators to the P3
                parking level. As you exit the elevator on P3, turn left
                and you will see the Autzu vehicles.
              </p>
              <img className="instructions__image" src={walk1} />
            </div>
            <br />
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot with my personal vehicle?
                  (free parking)
                </strong>
              </div>
              <img className="instructions__image" src={drive1} />
              <p className="instructions__body-text">
                You may enter the parking lot via Bloor St. W or St. George
                St. entrances. (Note: you must exit the parking lot via St.
                George St. only)
              </p>
              <img className="instructions__image" src={drive2} />
              <p className="instructions__body-text">
                Enter the parking lot ramp and the parking gate will open
                automatically. Drive down to P3 and you will find the Autzu
                vehicles. You may park your personal vehicle for free in
                any of the Autzu reserved parking spots during the duration
                of your rental.
              </p>
            </div>
          </div>
        </div>
      </ScrollLock>
    </div>
  </Fragment>
);

export default BloorInstructions;



// WEBPACK FOOTER //
// ./src/components/Static/ParkingLots/Toronto/BloorInstructions.js